export const environment = {
    production: true,
    baseUrl: 'https://ws-mob-web-api.togocom.tg/businessportaltogo/1.0/api',
    defaultPin: '1357',
    Encryption_Decryption_Key: "9qfGHcg0NlMac9pJr7phX6Jj+8dAm3vjjHb3rn839l4=",
    IV: "vsuBiyBMi1xGEO3q1fRfZQ==",
    encryptionKey: '3a9Fm3xY2PcU6sN5C7WzQv7R4hL0allX',
    //baseUrl: 'https://localhost:8081/api'
};
